import React from 'react'

function ReminderCard() {
  return (
    <div>ReminderCard</div>
  )
}

export default ReminderCard